import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {createAction as typedCreateAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'SAFEGUARDING';

export const {
    action: fetchReports,
    success: fetchReportsSuccess,
    failed: fetchReportsFailed,
} = createAction(
    `${domain}/FETCH_REPORTS`,
    (
        institutionId: string,
        kinds: string[],
        from: string | undefined,
        to: string | undefined,
        location: string | undefined,
        childIds: string | undefined,
        reporterIds: string | undefined,
        cursor: string | null,
    ) => ({institutionId, kinds, from, to, location, childIds, reporterIds, cursor}),
    (apiData: any, append: boolean) => ({apiData, append}),
);

export const {
    action: initialFetchReports,
    success: initialFetchReportsSuccess,
    failed: initialFetchReportsFailed,
} = createAction(
    `${domain}/INITIAL_FETCH_REPORTS`,
    (
        institutionId: string,
        kinds: string[],
        from: string | undefined,
        to: string | undefined,
        location: string | undefined,
        childIds: string | undefined,
        reporterIds: string | undefined,
        cursor: string | null,
    ) => ({institutionId, kinds, from, to, location, childIds, reporterIds, cursor}),
    (apiData: any, append: boolean) => ({apiData, append}),
);

export const {action: hideEmptyState} = typedCreateAction(`${domain}/HIDE_EMPTY_STATE`, () => ({}));
